import { render, staticRenderFns } from "./m-input-form.vue?vue&type=template&id=57b51734&"
import script from "./m-input-form.vue?vue&type=script&lang=js&"
export * from "./m-input-form.vue?vue&type=script&lang=js&"
import style0 from "./m-input-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports